<template>
<div class="testimonials">
  <p class="text-center"><button @click.prevent="openForm" v-if="!visible" class="btn btn-secondary">Bewertung abgeben</button></p>
  <div v-if="visible" class="contact__wrapper testimonials-form">
  <v-app>
    <contact-form :name="name" buttonText="Bewertung abgeben" :requiredFields="requiredFields">
      <h2 class="has-text-align-center">Kundenstimme abgeben</h2>

      <testimonial-form></testimonial-form>

      <template slot="disclaimer">
          Mit der Erfassung, Speicherung, Verwendung und Veröffentlichung meiner Bewertung bin ich einverstanden.
          Hinweis: Sie können Ihre Einwilligung jederzeit widerrufen.
      </template>
    </contact-form>
  </v-app>
  </div>
</div>
</template>

<script>
import ContactForm from "./ContactForm.vue";
import TestimonialForm from "./TestimonialForm.vue";

export default {
  name: "TestimonialApp",

  components: {
    ContactForm,
    TestimonialForm
  },

  data() {
    return {
      name: "testimonials",
      visible: false
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    }
  },

  methods: {
    openForm() {
      this.visible = !this.visible;

      this.$nextTick(() => {
        let element = this.$el;
        let offsetTop = element.offsetTop - 100;

        window.scrollTo({top: offsetTop, behavior: 'smooth'});
      });
    }
  }
};
</script>
